import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import localeData from "dayjs/plugin/localeData";
//import utc from 'dayjs/plugin/utc'
//import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek';

import "dayjs/locale/tr";
import "dayjs/locale/en";

dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(isoWeek);
//dayjs.extend(utc);
//dayjs.extend(timezone);

dayjs.locale("tr");

// API saat damgasını şubenin duvar saatinde döner; JSON'daki offset sunucu makinesinin
// dilimidir. Atılmazsa değer tarayıcı dilimine ikinci kez kaydırılır.
export function stripServerOffset(value) {
    if (typeof value !== "string" || value.indexOf("T") === -1) return value;
    return value.replace(/(?:Z|[+-]\d{2}:?\d{2})$/, "");
}

export function wallClock(value) {
    return dayjs(stripServerOffset(value));
}

export default dayjs;